import { createContext } from 'react';
import { TriggerContextProps } from './types';

const TriggerContext = createContext<TriggerContextProps>({});

export default TriggerContext;